import React, { useState } from "react";
import {
    Typography,
    ButtonGroup,
    Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik } from "formik";
import { patchMultipleDesignsAndAddLoop } from "../DesignActions";
import StepperButtons from "../../StepperButtons";
import InformationDialogue from "../../../CustomComponents/InformationDialogue";
import { discussion } from "../../../../context/designPhase";
import DiscussionChoices from "./DiscussionChoices";


export default function DesignDiscussion({ handleAdvancePhase, payload }) {
    const dispatch = useDispatch();
    const project = useSelector((state) => state.projects.selectedProject);
    const referenceDesign = payload?.loop?.reference_design;
    const sortedDesigns = [...payload?.loop?.designs || []].sort((a, b) => a.name.localeCompare(b.name));
    let designs = referenceDesign ? [referenceDesign, ...sortedDesigns] : sortedDesigns;

    payload.editable = payload.loop === payload.project.phases.slice(-1)[0].loops.slice(-1)[0] ? payload.editable : false;

    //This is the design that is preferred to continue in the next phase
    const [preferredDesign] = useState(undefined);
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const advancePhase = () => {
        handleAdvancePhase(designs.find((design) => design.id === preferredDesign));
    };
    
    const addLoop = (values) => {
        patchMultipleDesignsAndAddLoop(values, project.id, payload.phase.id, payload.loop.id, dispatch);
    };

    if (designs) {
        return (
            <>
                <InformationDialogue text={discussion}/>

                    <Formik
                        initialValues={{
                            preferred: designs.reduce((acc, design) => {
                                if (design) return { ...acc, [design.id]: design.is_preferred ? design.is_preferred : false };
                            }, {}),
                            comments: designs.reduce((acc, design) => {
                                if (design) return { ...acc, [design.id]: design.comment };
                            }, {}),
                            loopComment: payload?.loop?.comment || "",
                            recommendations: payload?.loop?.recommendations || [],
                            decisions: payload?.loop?.decisions || [],
                        }}
                        enableReinitialize
                    >
                        {({ values, setValues }) => (
                            <Form>
                                <DiscussionChoices
                                    designs={designs}
                                    referenceDesign={referenceDesign}
                                    payload={payload}
                                    dispatch={dispatch}
                                    values={values}
                                    setValues={setValues}
                                />
                                {/* <Divider sx={{ marginTop: 6, marginBottom: 2 }} /> */}
                                {project.user_is_owner && <ButtonGroup sx={{ marginTop: "10px", display: "block" }}>
                                    {!(payload?.phase?.id < project?.phases?.length) && (
                                        <Button sx={{ paddingLeft: "25px" }} onClick={advancePhase} disabled={!payload.editable}>
                                            Volgende fase {preferredDesign === undefined ? "" : "met voorkeursontwerp"}
                                        </Button>
                                    )}
                                    {!(payload?.phase.id < project.phases.length || payload?.loop?.id < payload?.phase?.loops?.length - 1) && (
                                        <Button sx={{ paddingLeft: "25px" }} onClick={() => addLoop(values)} disabled={!payload.editable}>
                                            Ontwerpronde toevoegen
                                        </Button>
                                    )}
                                </ButtonGroup>}
                            </Form>
                        )}
                    </Formik>
                <StepperButtons payload={payload} />
            </>
        );
    } else {
        return <Typography>Geen ontwerpen gevonden</Typography>;
    }
}
